export interface GetBenefitPeriodsResponse {
  benefitPeriods: { startDate: string; endDate: string }[];
}
